import React from "react";

import "./help.scss";

type Props = Readonly<{
  review: boolean;
}>;

const HelpComponent = ({ review }: Props) => {
  return (
    <div className="mapping-help">
      <h1>Hotkeys</h1>
      <dl>
        <dt>
          <kbd>TAB</kbd> / <kbd>&darr;</kbd>
        </dt>
        <dd>next data point</dd>
        <dt>
          <kbd>SHIFT</kbd> + <kbd>TAB</kbd> / <kbd>&uarr;</kbd>
        </dt>
        <dd>previous data point</dd>
        {!review && (
          <>
            <dt>
              <kbd>CLICK</kbd>
            </dt>
            <dd>select support for data point</dd>
            <dt>
              <kbd>CTRL</kbd> + <kbd>CLICK</kbd>
            </dt>
            <dd>select support and populate data point</dd>
          </>
        )}
        <dt>
          <kbd>SHIFT</kbd> + <kbd>CLICK</kbd>
        </dt>
        <dd>show data points referencing this block (pages view only)</dd>
        <dt>
          <kbd>ALT</kbd> + <kbd>CLICK</kbd>
        </dt>
        <dd>show text editor widget in page view (BETA - text blocks only)</dd>
      </dl>
    </div>
  );
};
export const Help = React.memo(HelpComponent);
